import { render, staticRenderFns } from "./_epic2.vue?vue&type=template&id=01e90fa0&lang=pug&"
import script from "./_epic2.vue?vue&type=script&lang=js&"
export * from "./_epic2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports